/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBody
 */
/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }

  .loader {
    position: absolute !important;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    color: #5e5e5e;
    z-index: 2000;
  }
`;



export const Groupbutton = styled.div`
  .wrap-buttons{
    margin:6px 0;
    display: flex;
    justify-content: end;
    align-items: center;
    align-content: center;
    column-gap: 8px;
      .buffer-actions{
        display: flex;
        align-items: center;
        column-gap: 12px;
      }
  }

  button {
    color: #3C71DD;
    margin: 0px 0px;
    padding: 0px;
    outline: none;
  }

  button:hover {
    border: none;
  }
  
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  button:nth-child(3){
    width: 62.11px;
    height: 32px !important;
    border-radius: 3px;
    background: #3C71DD;
    color: #FFFFFFCC;
    &.disabled{
      opacity: 90%;
      color: #FFFFFFCC;
      background: #4F5B78 !important;   
    }
  }
`;

export const ModalContainer = styled.div`
position: relative;

.modal-int {
  position: absolute;
  background: #1F2D4D;
  width: 302.84px;
  padding: 2px 16px 0px 16px;
  border-radius: 2px;

  .wrap-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 0.75px solid #ABABAB;

    color: #ABABAB;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 300;
    margin-top: 8px;
    padding-bottom: 8px;

    svg{
      width: 12px;
      height: 16px;
      margin-top: 6px;
    }

    .close-modal{
      cursor: pointer;
    }
    
  }

  .form-group{
    display: flex;
    flex-direction: column;
    padding: 0px 12px 0px 12px;
    margin-bottom: 0px;
    .row-1, .row-2{
      display: flex;
      column-gap: 15px;
      margin-top: 14px;

        label{
          font-family: Roboto;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          color: #FFFFFFCC;
          margin-bottom: 2px;
        }
        .col-1, .col-3{
          display: flex;
          flex-direction: column;
          align-items: start;
          .value-label{
            display: flex;
            align-items: center;
            justify-content: space-between;           
            width: 155px;
            height: 40px;
            padding: 0 12px;
            background: #ffffff;
            border-radius: 3px;
          }
        }
        .col-2{
          display: flex;
          flex-direction: column;
          align-items: start;
          .value-label{
            display: flex;
            align-items: center;
            justify-content: space-between;           
            width: 125.56px;
            height: 40px;
            padding: 0 12px;
            background: #ffffff;
            border-radius: 3px;
          }
        }
    }

      input#masked-input {
      background: #FFFFFF;
      width: 121.657px;
      height: 40px;
    }

     select:disabled {
      background: #414C68;  opacity: 0.6; /* Ajuste a opacidade conforme necessário */
      color: #7A8295;
    }
  }
}
`;

export const Geometry = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  height: 60px;

  .typeGeometry{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 41px;
    width: 80.95px;
    color: #7A8295;
    background: #414C68;
    border-radius: 3px;
  }
`;

export const Distance = styled.div`
display: flex;
flex-direction: column;
align-items: start;
width: 149.89px;
height: 60px;
box-sizing: border-box;

  .distanceBuffer{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 149.89px;
    height: 40px;
    padding: 0 12px;
    background: #ffffff;
    border-radius: 3px;
    
      input {
        background: #FFFFFF;
        width: 70px;
        height: 100%;
        border: none;
      }
      hr {
        border-left: 1px solid #cccccc;
        margin: 0 px;
        height: 22px;
      }
      button{
        margin-left: 0px;
      }
  }

`;
